import { useUserAuthQuery } from 'auth/hooks'
import { isLoggedInQuerySelector } from 'auth/selectors'

export function useIsLoggedInQuery() {
  return useUserAuthQuery(undefined, {
    select: isLoggedInQuerySelector,
  })
}
